import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
import { Spritesheet, Texture } from "pixi.js";
export class UpgradeResourcePackage extends BundleResourcesPackage {
    public constructor() {
        super("UpgradeResourcePackage");
    }
    public get assets_views_upgrade_building_frame_building_frame_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/upgrade/building_frame/building_frame_1x.atlas.json");
    }
    public get assets_views_upgrade_building_frame_light_png(): Texture {
        return this.assets_views_upgrade_building_frame_building_frame_1x_atlas_json.textures["light.png"];
    }
    public get assets_views_upgrade_building_frame_building_frame_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/upgrade/building_frame/building_frame_1x.atlas.png");
    }
    public get assets_views_upgrade_button_button_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/upgrade/button/button_1x.atlas.json");
    }
    public get assets_views_upgrade_button_button_green_without_shadow_png(): Texture {
        return this.assets_views_upgrade_button_button_1x_atlas_json.textures["button_green_without_shadow.png"];
    }
    public get assets_views_upgrade_button_button_locked_png(): Texture {
        return this.assets_views_upgrade_button_button_1x_atlas_json.textures["button_locked.png"];
    }
    public get assets_views_upgrade_button_button_orange_without_shadow_png(): Texture {
        return this.assets_views_upgrade_button_button_1x_atlas_json.textures["button_orange_without_shadow.png"];
    }
    public get assets_views_upgrade_button_back_to_lobby_png(): Texture {
        return this.assets_views_upgrade_button_button_1x_atlas_json.textures["back_to_lobby.png"];
    }
    public get assets_views_upgrade_button_button_coin_icon_png(): Texture {
        return this.assets_views_upgrade_button_button_1x_atlas_json.textures["button_coin_icon.png"];
    }
    public get assets_views_upgrade_button_button_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/upgrade/button/button_1x.atlas.png");
    }
    public get assets_views_upgrade_hints_hints_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/upgrade/hints/hints_1x.atlas.json");
    }
    public get assets_views_upgrade_hints_button_green_long_png(): Texture {
        return this.assets_views_upgrade_hints_hints_1x_atlas_json.textures["button_green_long.png"];
    }
    public get assets_views_upgrade_hints_hints_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/upgrade/hints/hints_1x.atlas.png");
    }
    public get assets_views_upgrade_particles_particles_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/upgrade/particles/particles_1x.atlas.json");
    }
    public get assets_views_upgrade_particles_cube_7_png(): Texture {
        return this.assets_views_upgrade_particles_particles_1x_atlas_json.textures["cube_7.png"];
    }
    public get assets_views_upgrade_particles_cube_5_png(): Texture {
        return this.assets_views_upgrade_particles_particles_1x_atlas_json.textures["cube_5.png"];
    }
    public get assets_views_upgrade_particles_cube_3_png(): Texture {
        return this.assets_views_upgrade_particles_particles_1x_atlas_json.textures["cube_3.png"];
    }
    public get assets_views_upgrade_particles_cube_10_png(): Texture {
        return this.assets_views_upgrade_particles_particles_1x_atlas_json.textures["cube_10.png"];
    }
    public get assets_views_upgrade_particles_cube_4_png(): Texture {
        return this.assets_views_upgrade_particles_particles_1x_atlas_json.textures["cube_4.png"];
    }
    public get assets_views_upgrade_particles_cube_2_png(): Texture {
        return this.assets_views_upgrade_particles_particles_1x_atlas_json.textures["cube_2.png"];
    }
    public get assets_views_upgrade_particles_cube_6_png(): Texture {
        return this.assets_views_upgrade_particles_particles_1x_atlas_json.textures["cube_6.png"];
    }
    public get assets_views_upgrade_particles_cube_8_png(): Texture {
        return this.assets_views_upgrade_particles_particles_1x_atlas_json.textures["cube_8.png"];
    }
    public get assets_views_upgrade_particles_cube_9_png(): Texture {
        return this.assets_views_upgrade_particles_particles_1x_atlas_json.textures["cube_9.png"];
    }
    public get assets_views_upgrade_particles_cube_1_png(): Texture {
        return this.assets_views_upgrade_particles_particles_1x_atlas_json.textures["cube_1.png"];
    }
    public get assets_views_upgrade_particles_particles_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/upgrade/particles/particles_1x.atlas.png");
    }
    public get assets_views_upgrade_progress_bar_progress_bar_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/upgrade/progress_bar/progress_bar_1x.atlas.json");
    }
    public get assets_views_upgrade_progress_bar_progress_bar_bg_png(): Texture {
        return this.assets_views_upgrade_progress_bar_progress_bar_1x_atlas_json.textures["progress_bar_bg.png"];
    }
    public get assets_views_upgrade_progress_bar_progress_bar_fill_png(): Texture {
        return this.assets_views_upgrade_progress_bar_progress_bar_1x_atlas_json.textures["progress_bar_fill.png"];
    }
    public get assets_views_upgrade_progress_bar_progress_bar_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/upgrade/progress_bar/progress_bar_1x.atlas.png");
    }
    public get assets_views_upgrade_token_tutorial_token_tutorial_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/upgrade/token_tutorial/token_tutorial_1x.atlas.json");
    }
    public get assets_views_upgrade_token_tutorial_token_tooltip_png(): Texture {
        return this.assets_views_upgrade_token_tutorial_token_tutorial_1x_atlas_json.textures["token_tooltip.png"];
    }
    public get assets_views_upgrade_token_tutorial_token_png(): Texture {
        return this.assets_views_upgrade_token_tutorial_token_tutorial_1x_atlas_json.textures["token.png"];
    }
    public get assets_views_upgrade_token_tutorial_token_tutorial_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/upgrade/token_tutorial/token_tutorial_1x.atlas.png");
    }
    public get assets_views_upgrade_upgrade_cards_upgrade_cards_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/upgrade/upgrade_cards/upgrade_cards_1x.atlas.json");
    }
    public get assets_views_upgrade_upgrade_cards_elements_doneBg_png(): Texture {
        return this.assets_views_upgrade_upgrade_cards_upgrade_cards_1x_atlas_json.textures["elements/doneBg.png"];
    }
    public get assets_views_upgrade_upgrade_cards_elements_fix_label_png(): Texture {
        return this.assets_views_upgrade_upgrade_cards_upgrade_cards_1x_atlas_json.textures["elements/fix_label.png"];
    }
    public get assets_views_upgrade_upgrade_cards_elements_lock_label_png(): Texture {
        return this.assets_views_upgrade_upgrade_cards_upgrade_cards_1x_atlas_json.textures["elements/lock_label.png"];
    }
    public get assets_views_upgrade_upgrade_cards_elements_coin_png(): Texture {
        return this.assets_views_upgrade_upgrade_cards_upgrade_cards_1x_atlas_json.textures["elements/coin.png"];
    }
    public get assets_views_upgrade_upgrade_cards_upgrade_cards_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/upgrade/upgrade_cards/upgrade_cards_1x.atlas.png");
    }
    public get assets_views_upgrade_upgrade_panel_upgrade_panel_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/upgrade/upgrade_panel/upgrade_panel_1x.atlas.json");
    }
    public get assets_views_upgrade_upgrade_panel_locked_ribbon_png(): Texture {
        return this.assets_views_upgrade_upgrade_panel_upgrade_panel_1x_atlas_json.textures["locked_ribbon.png"];
    }
    public get assets_views_upgrade_upgrade_panel_upgrade_panel_frame_png(): Texture {
        return this.assets_views_upgrade_upgrade_panel_upgrade_panel_1x_atlas_json.textures["upgrade_panel_frame.png"];
    }
    public get assets_views_upgrade_upgrade_panel_light1_png(): Texture {
        return this.assets_views_upgrade_upgrade_panel_upgrade_panel_1x_atlas_json.textures["light1.png"];
    }
    public get assets_views_upgrade_upgrade_panel_light2_png(): Texture {
        return this.assets_views_upgrade_upgrade_panel_upgrade_panel_1x_atlas_json.textures["light2.png"];
    }
    public get assets_views_upgrade_upgrade_panel_light3_png(): Texture {
        return this.assets_views_upgrade_upgrade_panel_upgrade_panel_1x_atlas_json.textures["light3.png"];
    }
    public get assets_views_upgrade_upgrade_panel_resource_bar_png(): Texture {
        return this.assets_views_upgrade_upgrade_panel_upgrade_panel_1x_atlas_json.textures["resource_bar.png"];
    }
    public get assets_views_upgrade_upgrade_panel_resource_bar_fix_png(): Texture {
        return this.assets_views_upgrade_upgrade_panel_upgrade_panel_1x_atlas_json.textures["resource_bar_fix.png"];
    }
    public get assets_views_upgrade_upgrade_panel_resource_bar_green_png(): Texture {
        return this.assets_views_upgrade_upgrade_panel_upgrade_panel_1x_atlas_json.textures["resource_bar_green.png"];
    }
    public get assets_views_upgrade_upgrade_panel_separetor_png(): Texture {
        return this.assets_views_upgrade_upgrade_panel_upgrade_panel_1x_atlas_json.textures["separetor.png"];
    }
    public get assets_views_upgrade_upgrade_panel_back_button_png(): Texture {
        return this.assets_views_upgrade_upgrade_panel_upgrade_panel_1x_atlas_json.textures["back_button.png"];
    }
    public get assets_views_upgrade_upgrade_panel_upgrade_panel_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/upgrade/upgrade_panel/upgrade_panel_1x.atlas.png");
    }
    public get assets_views_upgrade_upgrade_resources_upgrade_resources_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/upgrade/upgrade_resources/upgrade_resources_1x.atlas.json");
    }
    public get assets_views_upgrade_upgrade_resources_out_of_coins_bg_png(): Texture {
        return this.assets_views_upgrade_upgrade_resources_upgrade_resources_1x_atlas_json.textures["out_of_coins_bg.png"];
    }
    public get assets_views_upgrade_upgrade_resources_gold_png(): Texture {
        return this.assets_views_upgrade_upgrade_resources_upgrade_resources_1x_atlas_json.textures["gold.png"];
    }
    public get assets_views_upgrade_upgrade_resources_green_diamonds_png(): Texture {
        return this.assets_views_upgrade_upgrade_resources_upgrade_resources_1x_atlas_json.textures["green_diamonds.png"];
    }
    public get assets_views_upgrade_upgrade_resources_purple_diamonds_png(): Texture {
        return this.assets_views_upgrade_upgrade_resources_upgrade_resources_1x_atlas_json.textures["purple_diamonds.png"];
    }
    public get assets_views_upgrade_upgrade_resources_upgrade_resources_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/upgrade/upgrade_resources/upgrade_resources_1x.atlas.png");
    }
}

